import { createFileRoute } from "@tanstack/react-router";
import { LegalDocumentPage } from "@/features/legal/components/LegalDocumentPage";
import { i18n } from "@/lib/i18n";
import { buildHead } from "@/lib/seo/head";
import { siteUrl } from "@/lib/seo/siteUrl";

// Public Polityka prywatności page (#305, ADR-0019). Renders the latest published
// markdown for the `polityka-prywatnosci` slug; the generic `LegalDocumentPage`
// owns fetch + states.
//
// A public route (ADR-0053 §2): prerendered to static HTML with a real baked
// `<head>` via the pure `buildHead` (#355). The document body is CMS-backed and
// hydrates client-side, but its title/description/canonical/OG are static per
// slug, so they bake deterministically — no image and no price, so the Twitter
// card is `summary` and no Product/Offer is emitted.
export const Route = createFileRoute("/polityka-prywatnosci")({
  ssr: true,
  head: () =>
    buildHead({
      path: "/polityka-prywatnosci",
      locale: i18n.resolvedLanguage ?? "pl",
      siteUrl: siteUrl(),
      content: {
        title: i18n.t("legal:meta.polityka-prywatnosci.title"),
        description: i18n.t("legal:meta.polityka-prywatnosci.description"),
      },
    }),
  component: () => <LegalDocumentPage slug="polityka-prywatnosci" />,
});
